import _MSI4 from "./MSI.js";
import _checksums2 from "./checksums.js";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MSI2 = _MSI4;
var _MSI3 = _interopRequireDefault(_MSI2);
var _checksums = _checksums2;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var MSI11 = function (_MSI) {
  _inherits(MSI11, _MSI);
  function MSI11(data, options) {
    _classCallCheck(this, MSI11);
    return _possibleConstructorReturn(this, (MSI11.__proto__ || Object.getPrototypeOf(MSI11)).call(this, data + (0, _checksums.mod11)(data), options));
  }
  return MSI11;
}(_MSI3.default);
exports.default = MSI11;
export default exports;